module.exports = __webpack_public_path__ + "media/images/favicon/android-icon-36x36-59711e5e705ae9c9517059074f8e3e26.png";